var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mailtoHref
    ? _c("div", { staticClass: "request-freight-quote" }, [
        _c("span", { staticClass: "request-freight-quote__text" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("freightQuote.banner.prompt")) +
              "\n    "
          )
        ]),
        _c(
          "a",
          {
            staticClass: "request-freight-quote__link",
            attrs: { href: _vm.mailtoHref }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("freightQuote.banner.linkText")) +
                "\n    "
            )
          ]
        ),
        _c("span", { staticClass: "request-freight-quote__text" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("freightQuote.banner.suffix")) +
              "\n    "
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }